import { ALL_VALUE } from 'site-modules/shared/constants/incentives/electric-car-incentives';

const maybe = value => {
  const map = fn => maybe(value ? fn(value) : undefined);
  const unpack = () => value;
  return Object.assign(map, { map, unpack });
};

const checkIsAllValue = value => (value === ALL_VALUE ? undefined : value);

const checkLength = arr => (Array.isArray(arr) && arr.length ? arr : undefined);

const wrapInArray = value => (Array.isArray(value) ? value : [value]);

const wrapIn = value => ({ in: wrapInArray(value) });

const wrapNotIn = value => ({ notIn: wrapInArray(value) });

const wrapNotInOrIn = excludedValue => includedValue => {
  const isExcludedValue = Array.isArray(excludedValue) ? excludedValue.length : excludedValue;
  const isIncludedValue = Array.isArray(includedValue) ? includedValue.length : includedValue;

  if (!isExcludedValue && !isIncludedValue) {
    return undefined;
  }
  return !isIncludedValue && isExcludedValue ? wrapNotIn(excludedValue) : wrapIn(includedValue);
};

export { maybe, checkIsAllValue, checkLength, wrapIn, wrapNotIn, wrapNotInOrIn, wrapInArray };
